import {datatables} from '#/js/inline/datatables';
import axios from 'axios';

export default function() {
  datatables();
  const listTable = $('#revenueTable');
  let table = listTable.DataTable({
    dom: 'Bfrtip',
    searching: false,
    columnDefs: [
      {
        'targets': 0,
        'visible': false,
        'orderable': false,
      },
    ],
  });

  function dataToHtml(data) {
    return `
      <div>Income: ${data.income}</div>
      <div>Tax: ${data.tax}</div>`;
  }

  function format(rowData) {
    let div = $('<div class="pl-5"></div>').
        addClass('loading').
        text(window.Lang.get('general.loading'));

    const promise = axios.get(`/payableRevenues/${rowData[0]}/getSplit`);
    promise.then(response => {
      const data = response.data.data || {
        income: 0,
        tax: 0,
      };
      div.html(dataToHtml(data)).removeClass('loading');
    }).catch(error => {
      div.text(window.Lang.get('general.status.failed')).removeClass('loading');
    });

    return div;
  }

  function clicked() {
    let tr = $(this).closest('tr');
    let row = table.row(tr);

    if (row.child.isShown()) {
      row.child.hide();
      tr.removeClass('shown');

      return;
    }

    row.child(format(row.data())).show();
    tr.addClass('shown');
  }

  listTable.on('click', 'tr.revenueRow.hasDetails', clicked);
};
